import React from 'react'
import Resume from '../components/Resume'

import MainPageLayout from '../components/MainPageLayout'

const ResumeDis = () => {
  return (
    <MainPageLayout>
          <Resume />
    </MainPageLayout>
  )
}

export default ResumeDis